import React from "react";
import styles from "./styles.module.scss";

const Billing = () => {
    return (
        <div className={styles.billing}>
            <div>Billing Component</div>
        </div>
    );
};

export default Billing;
